export default __webpack_public_path__ + "img/icon-flag-es.asset.old.38630f25.jpg";